import type { GetB2bCampaignsPayoutsOneResponse } from '@Common/types/b2b/campaigns';

export const b2bPayoutsTranslations = {
  status: {
    pending: 'En cours',
    completed: 'Éxécuté',
    cancelled: 'Annulé',
  } satisfies Record<GetB2bCampaignsPayoutsOneResponse['status'], string>,
  payout_by_company_warning:
    "Il n'y a pas de mdlr_transfer car le règlement immédiat est payé par l'entreprise",
  payout_by_company_warning_external:
    "Ce règlement immédiat est payé directement par votre entreprise: aucun virement n'est effectué par Shares",
};
